/**
 * Turn a Date (or date-string) into a YYYYMMDD integer.
 *
 * @param dateInput  A Date object or any string accepted by `new Date(...)`
 * @returns          Number of the form YYYYMMDD, e.g. 20250716
 */
export function toYYYYMMDDInt(dateInput: Date | string): number {
  const d = new Date(dateInput);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return Number(`${y}${m}${day}`);
}
